import type { NotificationPlacement } from "antd/es/notification/interface";
import type { NotificationInstance } from "antd/es/notification/interface";
import { useNotification } from "../components/NotificationProvider";

export interface NotificationConfig {
  message: string;
  description?: string | React.ReactNode;
  duration?: number;
  placement?: NotificationPlacement;
}

// Global notification instance for non-React contexts (like sagas)
let globalNotificationApi: NotificationInstance | null = null;

export const setGlobalNotificationApi = (api: NotificationInstance) => {
  globalNotificationApi = api;
};

// Standalone notification API for non-React contexts (like sagas)
export const notify = {
  success: (config: NotificationConfig) => {
    if (globalNotificationApi) {
      globalNotificationApi.success(config);
    }
  },
  error: (config: NotificationConfig) => {
    if (globalNotificationApi) {
      globalNotificationApi.error(config);
    }
  },
  info: (config: NotificationConfig) => {
    if (globalNotificationApi) {
      globalNotificationApi.info(config);
    }
  },
  warning: (config: NotificationConfig) => {
    if (globalNotificationApi) {
      globalNotificationApi.warning(config);
    }
  },
};

// Hook for use within React components
export const useNotify = () => {
  const notify = useNotification();
  return notify;
};
